export default "__VITE_PUBLIC_ASSET__b8231bf7__"